/**
 * Share Service
 * API calls for sharing content to users via DM
 */

import { apiClient } from "@/lib/api-client"

export interface ShareRequest {
  userIds: string[]
  message: string
  shareUrl: string
  shareType: "ritual" | "community" | "profile"
}

export interface ShareResponse {
  success: boolean
  message: string
  data: {
    sent: number
    failed: number
    errors?: string[]
  }
}

export async function sendShareMessage(request: ShareRequest): Promise<ShareResponse> {
  const response = await apiClient.post<ShareResponse>("/api/share/send", request)
  return response.data
}
